import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TranslatorService {

  private currentLanguageValues = {};

  // private listOfPermittedLocales = ['en_US', 'es', 'es_ES', 'fr_CA', 'fr_FR', 'it_IT', 'de_DE', 'pt_PT', 'pt_BR', 'ja_JP'];
  // Updated Nov 13, 2023 for other Spanish Speaking Countries as a part of ADO US 999625, starting from es_AR. This is the 1st part of 2 code changes for this change
  private listOfPermittedLocales = ['en_US', 'es_US', 'en_CA', 'fr_CA', 'pt_BR', 'es_CL', 'es_CO', 'es_AR', 'es_BO', 'es_CR', 'es_DO', 'es_EC', 'es_SV', 'es_GT', 'es_HN', 'es_MX', 'es_NI', 'es_PA', 'es_PY', 'es_PE', 'es_UY', 'es_PR'];

  constructor() {
    this.currentLanguageValues = require(`./../../../../content/locale/en_US.json`);
  }

  loadTranslations(locale = 'en_US') {

    let json = {};

    if (this.listOfPermittedLocales.find(localeValue => localeValue === locale)) {
        json = require(`./../../../../content/locale/${locale}.json`);
    } else if (locale && this.listOfPermittedLocales.find(localeValue => localeValue === locale.split('_')[0])) {
        json = require(`./../../../../content/locale/${locale.split('_')[0]}.json`);
    } else {
        json = require(`./../../../../content/locale/en_US.json`);
    }

    this.currentLanguageValues = json;
  }

  getTranslations(forComponent: string) {
    return this.currentLanguageValues[forComponent];
  }

}
